'use strict';

var util = require('./../../../app_storefront_core_UI/cartridge/js/util');

module.exports = {
    init: function () {
        var $searchContainer = $('.js-search-form-holder');
        var $searchForm = $searchContainer.find('form[name="simpleSearch"]');
        var $searchField = $searchForm.find('input[name="q"]');
        var $searchClear = $searchForm.find('.js-input-clear');

        $(document).on('click', function (e) {
            if ($searchClear.is(e.target) && $searchField.val().length > 0 && $searchClear.hasClass('active')) {
                $searchField.val('');
                $searchField.focus();
                $searchClear.removeClass('active');
            }
        }.bind(this));
        // on key up listener
        $searchField.keyup(function (e) {

            //active cleare button
            if($searchField.val().length > 0) {
                $searchClear.addClass('active');
            } else {
                $searchClear.removeClass('active');
            }
        }.bind(this));
    }
};
